module.exports = __webpack_public_path__ + "img/logo1.0d16d9cc.png";